// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products {
    display: inline-flex;
    flex-wrap: wrap;
    max-width: 100%;

}

.card {
    max-width: 250px;
    display:'flex';
    flex-direction:'row';
}

.productButtonStyle {
    padding: 0.3em;
    border-style: solid;
    border-color: black;
    border-width: 1px;
    font-size: 1.2em;
    border-radius: .5em;
    background-color: rgb(200, 255, 255);
  }`, "",{"version":3,"sources":["webpack://./src/components/Products.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,eAAe;IACf,eAAe;;AAEnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oCAAoC;EACtC","sourcesContent":[".products {\n    display: inline-flex;\n    flex-wrap: wrap;\n    max-width: 100%;\n\n}\n\n.card {\n    max-width: 250px;\n    display:'flex';\n    flex-direction:'row';\n}\n\n.productButtonStyle {\n    padding: 0.3em;\n    border-style: solid;\n    border-color: black;\n    border-width: 1px;\n    font-size: 1.2em;\n    border-radius: .5em;\n    background-color: rgb(200, 255, 255);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
